import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomDateField from "../CustomComponents/CustomDateField";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import CustomTextField from "../CustomComponents/CustomTextField";
import { SecurityChequeReducerAction } from "../Store/SecurityCheque/SecurityChequeReducer";
import SecurityChequeList from "./SecurityChequeList";
import SecurityChequeInfo from "./SecurityChequeInfo";
import FileDetailsInfo from "./FileDetailsInfo";
import { Edit, Preview } from "@mui/icons-material";
import store from "./../Store/index";
import { SpecialAccessDetailAction } from "../Store/SpecialAccess/SpecialAccessDetailReducer";
import { BranchAction } from "../Store/Branch";
import { useRef } from "react";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import dayjs from "dayjs";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";

const SecurityChequeFilter = (props) => {
  //Creating Dispatch
  const dispatch = useDispatch();
  //Selecting from store
  const userName = useSelector((state) => state.branch.userName);

  const filterValues = useSelector(
    (state) => state.securityCheque.filterValues
  );

  const chequeDetailData = useSelector(
    (state) => state.securityCheque.chequeDetailData
  );

  const chequeGridRows = useSelector(
    (state) => state.securityCheque.chequeGridRows
  );

  const securityChequeInitialStateAfterFilter = useSelector(
    (state) => state.securityCheque.securityChequeInitialStateAfterFilter
  );

  //Getting value from the store
  const touchHandler = useSelector(
    (state) => state.securityCheque.touchHandler
  );
  const valueIsValid = useSelector(
    (state) => state.securityCheque.valueIsValid
  );
  const showChequeListGrid = useSelector(
    (state) => state.securityCheque.showChequeListGrid
  );

  const showFileDetailsInfo = useSelector(
    (state) => state.securityCheque.showFileDetailsInfo
  );

  const screenModeValue = useSelector(
    (state) => state.securityCheque.screenMode
  );

  //shortcut key
  const viewRef = useRef(null);
  const modifyRef = useRef(null);
  const detailRef = useRef(null);
  const detailChequeRef = useRef(null);
  const clearRef = useRef(null);
  const cancelRef = useRef(null);
  const cancelConfirmRef = useRef(null);
  const cancelModeRef = useRef(null);
  const yesConfirmRef = useRef(null);
  const yesModeRef = useRef(null);
  const okRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.addEventListener("keydown", onKeyUnmountEventHandler);
      window.addEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "securityFilter",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let date = new Date();
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.ctrlKey) {
      if (charCode === "k") {
        okRef.current.click();
      } else if (charCode === "q") {
        cancelRef.current !== null && cancelRef.current.click();
        cancelConfirmRef.current !== null && cancelConfirmRef.current.click();
        cancelModeRef.current !== null && cancelModeRef.current.click();
      } else if (charCode === "y") {
        yesConfirmRef.current !== null && yesConfirmRef.current.click();
        yesModeRef.current !== null && yesModeRef.current.click();
      } else if (charCode === "d") {
        clearRef.current.click();
      } else if (charCode === "f") {
        detailRef.current.click();
      } else if (charCode === "r") {
        detailChequeRef.current.click();
      } else if (charCode === "e") {
        viewRef.current.click();
      } else if (charCode === "m") {
        modifyRef.current.click();
      }
    }
  };
  //Error Status checking
  const branchHasError =
    touchHandler.branchTouched && !valueIsValid.branchIsValid;
  const applicationHasError =
    touchHandler.applicationNumTouched && !valueIsValid.applicationNumIsValid;
  const receiptDateHasError =
    touchHandler.receiptDateTouched && !valueIsValid.receiptDateIsValid;
  const repaymentTypeHasError =
    touchHandler.repaymentTypeTouched && !valueIsValid.repaymentTypeIsValid;
  const capacityHasError =
    touchHandler.capacityTouched && !valueIsValid.capacityIsValid;
  const blockNumberHasError =
    touchHandler.blockNumberTouched && !valueIsValid.blockNumberIsValid;

  const [receiptDateValidDateError, setReceiptDateValidDateError] =
    useState(false);
  const [open, setOpen] = useState(false);
  const [dlgInputMode, setDlgInputMode] = useState(false);
  // below are for discard confirm dialog.
  const [confirmDlgOpen, setConfirmDlgOpen] = useState(false);
  const [confirmDlgTitleMsg, setConfirmDlgTitleMsg] = useState("");
  const [confirmDlgMsg, setConfirmDlgMsg] = useState("");
  // the below current field trigger holds the last triggered field that triggers the confirm dialog.
  const [currentfieldTrigger, setCurrentFieldTrigger] = useState({});

  // mode switch confirm dlg.
  // Dialog msg content.
  const [modeSwitchDialogMessage, setModeSwitchDialogMessage] = useState("");
  const [modeSwitchDialogTitleMessage, setModeSwitchDialogTitleMessage] =
    useState("");
  //Maintainig State for Dialog while submitting the application
  const [modeSwitchDlgOpen, setModeSwitchDlgOpen] = useState(false);
  const [modeSwitchToView, setModeSwitchToView] = useState(false);

  const [loadFileInfoPanel, setLoadFileInfoPanel] = useState(false);
  const userId = store.getState().branch.userID;
  const moduleId = useSelector((state) => state.specialAccess.moduleId);
  const programId = useSelector((state) => state.specialAccess.programId);
  let fieldAccessMap = useSelector(
    (state) => state.specialAccess.fieldAccessMap
  );
  let paramValues = useSelector((state) => state.specialAccess.paramValues);
  //Branch onChangeHandler
  useEffect(() => {
    getFieldData();
  }, []);

  const getFieldData = async () => {
    let modeIdVal = "";
    const response = await axios.get("/specialAccess/getFieldAccess", {
      method: "get",
      params: {
        userId: userId,
        moduleId: moduleId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatch(SpecialAccessDetailAction.getFieldData(response.data));
  };
  let minDateAddValue = Number(0);
  let maxDateAddValue = Number(0);
  if (
    paramValues !== null &&
    paramValues !== undefined &&
    Object.keys(paramValues).length > 0
  ) {
    if (
      !(
        paramValues["Security Request Date Back Count"] &&
        new Date(
          paramValues["Security Request Date Back Count"]["paramEffStartDate"]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Security Request Date Back Count"]["paramEffEndDate"]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      minDateAddValue = 0;
    } else {
      minDateAddValue =
        fieldAccessMap.securityReceiptDateCreate &&
        fieldAccessMap.securityChequeCreateBackCount
          ? Number(
              paramValues["Security Request Date Back Count"]["paramValue"]
            )
          : Number(0);
    }
    if (
      !(
        paramValues["Security Request Date Future Count"] &&
        new Date(
          paramValues["Security Request Date Future Count"]["paramEffStartDate"]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Security Request Date Future Count"]["paramEffEndDate"]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      maxDateAddValue = 0;
    } else {
      maxDateAddValue =
        fieldAccessMap.securityReceiptDateCreate &&
        fieldAccessMap.securityChequeCreateFutureCount
          ? Number(
              paramValues["Security Request Date Future Count"]["paramValue"]
            )
          : Number(0);
    }
  }
  useEffect(() => {
    // Load values from the LOV Master API.
    const getLovMasterData = async () => {
      const securityPDCLovValues = await axios.post("/lovMaster/getLovValues", {
        moduleId: "MD010",
      });
      const lovData = securityPDCLovValues.data;
      dispatch(SecurityChequeReducerAction.updateLovDataValue(lovData));
      const targetFieldsData = Object.keys(lovData);
      dispatch(
        SecurityChequeReducerAction.updateLovTargetFields(targetFieldsData)
      );
      // update the repayment type lov values.
      const repaymentTypes = lovData?.["Repayment Type"].map(
        (record) => record.lovValues
      );
      const capacityTypes = lovData?.["Capacity"].map(
        (record) => record.lovValues
      );
      const bankOptions = lovData?.["Bank Option"].map(
        (record) => record.lovValues
      );
      dispatch(
        SecurityChequeReducerAction.updateRepaymentTypeArray([
          ...repaymentTypes,
        ])
      );
      dispatch(SecurityChequeReducerAction.updateCapacityArray(capacityTypes));
      dispatch(SecurityChequeReducerAction.updateBankOptionArray(bankOptions));
    };
    getLovMasterData();
    if (props.screenMode !== "CREATE") {
      dispatch(
        SecurityChequeReducerAction.updateScreenMode(
          screenModeValue === "" ? props.screenMode : screenModeValue
        )
      );
    } else {
      // create mode .
      dispatch(SecurityChequeReducerAction.updateBranchIsTouched(false));
      dispatch(
        SecurityChequeReducerAction.updateApplicationNumberIsTouched(false)
      );
      dispatch(SecurityChequeReducerAction.updateReceiptDateIsTouched(false));
      dispatch(SecurityChequeReducerAction.updateRepaymentTypeIsTouched(false));
      dispatch(SecurityChequeReducerAction.updateCapacityIsTouched(false));
      dispatch(SecurityChequeReducerAction.resetFilterValues());
      dispatch(
        SecurityChequeReducerAction.updateSecurityChequeInitialStateAfterFilter(
          {}
        )
      );
    }
    const branchArr = GetBranchDetails();
    dispatch(SecurityChequeReducerAction.updateBranchArray(branchArr));
    const getChequeTypes = async () => {
      const chequeTypesResponse = await axios.post(
        "/filereceipt/getChequeTypes",
        {
          apiCode: "CHEQUE_TYPE_LOV_API",
          createdBy: userName,
          lastModifiedBy: userName,
        }
      );
      if (Object.keys(chequeTypesResponse.data).length > 0) {
        const types =
          Number(chequeTypesResponse.data.status) === 1
            ? chequeTypesResponse.data.cheque_type
            : [];
        const chequetypes = types.map((type) => type.cheque_categorey_desc);
        dispatch(
          SecurityChequeReducerAction.updateChequeTypeArray([...chequetypes])
        );
      }
    };
    const getDraweerBanks = async () => {
      try {
        const response = await axios.post("/filereceipt/getDraweerBanks", {
          apiCode: "BANK_LIST_SHFL_API",
          createdBy: userName,
          lastModifiedBy: userName,
        });
        if (Object.keys(response.data).length > 0) {
          if (Number(response.data.status) === 1) {
            const bankLists = response.data.bank_list;
            const bankNames = bankLists.map((rec) => rec.bank_name);
            dispatch(
              SecurityChequeReducerAction.updateDraweerBanksArray(bankNames)
            );
            dispatch(
              SecurityChequeReducerAction.updateDraweerBanksMap(bankLists)
            );
          } else {
            dispatch(SecurityChequeReducerAction.updateDraweerBanksArray([]));
            dispatch(SecurityChequeReducerAction.updateDraweerBanksMap([]));
          }
        }
      } catch (error) {
        console.log(error);
        throw Error(error);
      }
    };
    getDraweerBanks();
    getChequeTypes();
    return () => {
      if (props.screenMode !== "CREATE") {
        dispatch(SecurityChequeReducerAction.updateScreenMode(""));
      }
      dispatch(SecurityChequeReducerAction.updateSaveBtnDisable(false));
    };
  }, [props.screenMode, screenModeValue]);

  const openConfirmDlg = (fieldType, fieldValue) => {
    setCurrentFieldTrigger({
      field: fieldType,
      value: fieldValue,
    });
    setConfirmDlgMsg("Do you want to discard the changes and continue ?");
    setConfirmDlgTitleMsg("Confirmation");
    setConfirmDlgOpen(true);
  };

  const handleConfirmDlgClose = () => {
    setCurrentFieldTrigger({});
    setConfirmDlgOpen(false);
  };

  const handleConfirmDlgOk = async () => {
    const field = currentfieldTrigger.field;
    if (field === "branch") {
      await branchOnChangeHandler(currentfieldTrigger.value);
      // reset the intial state after filter on the reducer to empty.
      dispatch(
        SecurityChequeReducerAction.updateSecurityChequeInitialStateAfterFilter(
          {}
        )
      );
    } else if (field === "applicationNum") {
      await onChangeApplicationNum(currentfieldTrigger.value);
      dispatch(
        SecurityChequeReducerAction.updateSecurityChequeInitialStateAfterFilter(
          {}
        )
      );
    } else if (field === "blockNumber") {
      await onChangeBlockNumber(currentfieldTrigger.value);
      dispatch(
        SecurityChequeReducerAction.updateSecurityChequeInitialStateAfterFilter(
          {}
        )
      );
    }
    // reset the current field & close the Dialog.
    setConfirmDlgOpen(false);
    setCurrentFieldTrigger({});
  };

  const getSelectedBranchCode = (branchValue) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === branchValue;
    });
    return branchCodeValue.code;
  };

  const branchOnChangeHandler = async (value) => {
    // reset  all the values on filter
    onClearBtnClickHandler();
    dispatch(SecurityChequeReducerAction.updateBranchValue(value));
    if (value && value !== "") {
      dispatch(BranchAction.updateHeaderBranchDetails(value));
      dispatch(SecurityChequeReducerAction.updateApplicationValue(null));
      try {
        const branchCodeValue = getSelectedBranchCode(value);
        const response = await axios.post("/losCustomer/getAppListByBranch", {
          branchName: value,
          screenMode:
            props.screenMode === "CREATE" ? props.screenMode : screenModeValue,
          branchCode: branchCodeValue,
        });
        const appNums = response.data.sort();
        dispatch(SecurityChequeReducerAction.updateApplicationArray(appNums));
        if (appNums.length === 1) {
          const appNumValue = appNums[0];
          dispatch(
            SecurityChequeReducerAction.updateApplicationValue(appNumValue)
          );
          if (appNumValue && appNumValue !== "") {
            const response = await axios.post(
              "/losCustomer/getCustomerDataByAppNum",
              {
                applicationNum: appNumValue,
              }
            );
            if (
              screenModeValue &&
              screenModeValue !== "" &&
              screenModeValue !== "CREATE"
            ) {
              const blockNumResponse = await axios.post(
                "/securityCheque/getBlockNumberList",
                {
                  branch: filterValues.branch,
                  applicationNum: appNumValue,
                  branchCode: getSelectedBranchCode(filterValues.branch),
                }
              );
              dispatch(
                SecurityChequeReducerAction.updateBlockNumberArray(
                  blockNumResponse.data
                )
              );
            }

            let record = response.data;
            let filterValuesData = {};
            filterValuesData.branch = filterValues.branch;
            filterValuesData.applicationNum = record.applicationNum;
            filterValuesData.customerId = record.customerId;
            filterValuesData.repayApp = "NACH";
            filterValuesData.repayMode = "NACH";
            filterValuesData.repaymentTypeArray = [
              "Disbursed",
              "Partially Disbursed",
            ];
            filterValuesData.capacityArray = ["Applicant", "Co-Applicant"];
            filterValuesData.losStatus = record.losStatus;
            if (record.losStatus === "Sanctioned") {
              filterValuesData.sanctionedDate = new Date(
                record.applicationDate
              );
              filterValuesData.tenure = record.tenure;
              filterValuesData.rateOfInterest = record.rateOfInterest;
              filterValuesData.sanctionAmt = record.sanctionAmt;
              dispatch(
                SecurityChequeReducerAction.updateFilterValues(filterValuesData)
              );
              dispatch(
                SecurityChequeReducerAction.updateShowFileDetailsInfo(false)
              );
              setLoadFileInfoPanel(false);
              dispatch(SecurityChequeReducerAction.resetFileDetailsData());
            } else {
              // when it's not sanctioned means requested or disbursed.
              // get the file details.
              const response = await axios.post(
                "/securityCheque/getFileDetails",
                {
                  applicationNum: record.applicationNum,
                }
              );
              if (response.data.length > 0) {
                let fileData = response.data[0];
                filterValuesData.ecdDate = fileData.emiCommDate;
                let fileDetails = {};
                fileDetails.applicationNum = record.applicationNum;
                fileDetails.emiStartDate = fileData.emiCommDate;
                const ecdd = new Date(
                  Number(fileData.firstEmiDueDate.split("/")[2]),
                  Number(fileData.firstEmiDueDate.split("/")[1]) - 1,
                  Number(fileData.firstEmiDueDate.split("/")[0])
                );
                const fbd = new Date(
                  Number(fileData.billingDate.split("/")[2]),
                  Number(fileData.billingDate.split("/")[1]) - 1,
                  Number(fileData.billingDate.split("/")[0])
                );
                fileDetails.emiDueDate = ecdd;
                fileDetails.fbdDay = fbd;
                fileDetails.emiAmt = fileData.sanctionedEmiAmt;
                dispatch(
                  SecurityChequeReducerAction.updateFileDetailsData(fileDetails)
                );
                dispatch(
                  SecurityChequeReducerAction.updateShowFileDetailsInfo(true)
                );
              }
              dispatch(
                SecurityChequeReducerAction.updateFilterValues(filterValuesData)
              );
            }
          }
        }
      } catch (error) {
        throw Error(error);
      }
    } else {
      // on bank clear.
      dispatch(SecurityChequeReducerAction.updateApplicationArray([]));
      dispatch(SecurityChequeReducerAction.updateApplicationValue(null));
      // reset  all the values on filter
      dispatch(SecurityChequeReducerAction.resetFilterValues());
      dispatch(
        SecurityChequeReducerAction.updateSecurityChequeInitialStateAfterFilter(
          {}
        )
      );
    }
  };

  const onChangeApplicationNum = async (value) => {
    const latestFilterData = store.getState().securityCheque.filterValues;
    // reset  all the values on filter
    onClearBtnClickHandler();
    await branchOnChangeHandler(latestFilterData.branch);
    // retaining back the last selected branch value
    dispatch(
      SecurityChequeReducerAction.updateBranchValue(latestFilterData.branch)
    );
    dispatch(SecurityChequeReducerAction.updateApplicationValue(value));
    if (value && value !== "") {
      const response = await axios.post(
        "/losCustomer/getCustomerDataByAppNum",
        {
          applicationNum: value,
        }
      );
      if (
        screenModeValue &&
        screenModeValue !== "" &&
        screenModeValue !== "CREATE"
      ) {
        const branchCodeValue = getSelectedBranchCode(filterValues.branch);
        const blockNumResponse = await axios.post(
          "/securityCheque/getBlockNumberList",
          {
            branch: filterValues.branch,
            applicationNum: value,
            branchCode: branchCodeValue,
          }
        );
        dispatch(
          SecurityChequeReducerAction.updateBlockNumberArray(
            blockNumResponse.data
          )
        );
      }

      let record = response.data;
      let filterValuesData = {};
      filterValuesData.branch = filterValues.branch;
      filterValuesData.applicationNum = record.applicationNum;
      filterValuesData.customerId = record.customerId;
      filterValuesData.repayApp = "NACH";
      filterValuesData.repayMode = "NACH";
      filterValuesData.repaymentTypeArray = [
        "Disbursed",
        "Partially Disbursed",
      ];
      filterValuesData.capacityArray = ["Applicant", "Co-Applicant"];
      filterValuesData.losStatus = record.losStatus;
      if (record.losStatus === "Sanctioned") {
        filterValuesData.sanctionedDate = new Date(record.applicationDate);
        filterValuesData.tenure = record.tenure;
        filterValuesData.rateOfInterest = record.rateOfInterest;
        filterValuesData.sanctionAmt = record.sanctionAmt;
        dispatch(
          SecurityChequeReducerAction.updateFilterValues(filterValuesData)
        );
        dispatch(SecurityChequeReducerAction.updateShowFileDetailsInfo(false));
        setLoadFileInfoPanel(false);
        dispatch(SecurityChequeReducerAction.resetFileDetailsData());
      } else {
        // when it's not sanctioned means requested or disbursed.
        // get the file details.
        const response = await axios.post("/securityCheque/getFileDetails", {
          applicationNum: record.applicationNum,
        });
        if (response.data.length > 0) {
          let fileData = response.data[0];
          filterValuesData.ecdDate = fileData.emiCommDate;
          let fileDetails = {};
          fileDetails.applicationNum = record.applicationNum;
          fileDetails.emiStartDate = fileData.emiCommDate;
          const ecdd = new Date(
            Number(fileData.firstEmiDueDate.split("/")[2]),
            Number(fileData.firstEmiDueDate.split("/")[1]) - 1,
            Number(fileData.firstEmiDueDate.split("/")[0])
          );
          const fbd = new Date(
            Number(fileData.billingDate.split("/")[2]),
            Number(fileData.billingDate.split("/")[1]) - 1,
            Number(fileData.billingDate.split("/")[0])
          );
          fileDetails.emiDueDate = ecdd;
          fileDetails.fbdDay = fbd;
          fileDetails.emiAmt = fileData.sanctionedEmiAmt;
          dispatch(
            SecurityChequeReducerAction.updateFileDetailsData(fileDetails)
          );
          dispatch(SecurityChequeReducerAction.updateShowFileDetailsInfo(true));
        }
        dispatch(
          SecurityChequeReducerAction.updateFilterValues(filterValuesData)
        );
      }
    }
  };

  const setFilterTouchHandlersActive = () => {
    dispatch(SecurityChequeReducerAction.updateBranchIsTouched(true));
    dispatch(
      SecurityChequeReducerAction.updateApplicationNumberIsTouched(true)
    );
    dispatch(SecurityChequeReducerAction.updateReceiptDateIsTouched(true));
    dispatch(SecurityChequeReducerAction.updateRepaymentTypeIsTouched(true));
    dispatch(SecurityChequeReducerAction.updateCapacityIsTouched(true));
    if (screenModeValue === "MODIFY") {
      dispatch(SecurityChequeReducerAction.updateBlockNumberIsTouched(true));
    }
  };

  const onClickChequeDetails = async (value) => {
    dispatch(SecurityChequeReducerAction.updateShowFileDetailsInfo(false));
    if (
      (screenModeValue &&
        screenModeValue !== "" &&
        screenModeValue === "MODIFY") ||
      props.screenMode === "CREATE"
    ) {
      setFilterTouchHandlersActive();
      if (
        valueIsValid.branchIsValid &&
        valueIsValid.applicationNumIsValid &&
        // valueIsValid.receiptDateIsValid &&
        !receiptDateValidDateError &&
        valueIsValid.repaymentTypeIsValid &&
        valueIsValid.capacityIsValid
      ) {
        if (chequeGridRows.length > 0) {
          dispatch(SecurityChequeReducerAction.updateShowChequeListGrid(true));
          dispatch(
            SecurityChequeReducerAction.updateShowFileDetailsInfo(false)
          );
          setLoadFileInfoPanel(false);
        } else {
          setOpen(true);
          setDlgInputMode(true);
        }
        // gathering the latest filter values for updating the initial state.
        if (props.screenMode === "MODIFY" || screenModeValue === "MODIFY") {
          const latestFilterValues =
            store.getState().securityCheque.filterValues;
          const latestChequeGridRows =
            store.getState().securityCheque.chequeGridRows;
          let initialStateValue = { ...latestFilterValues };
          initialStateValue.gridrows = [latestChequeGridRows];
          dispatch(
            SecurityChequeReducerAction.updateSecurityChequeInitialStateAfterFilter(
              { ...initialStateValue }
            )
          );
        }
      }
    } else if (
      screenModeValue &&
      screenModeValue !== "" &&
      screenModeValue === "VIEW"
    ) {
      dispatch(SecurityChequeReducerAction.updateBranchIsTouched(true));
      dispatch(
        SecurityChequeReducerAction.updateApplicationNumberIsTouched(true)
      );
      dispatch(SecurityChequeReducerAction.updateBlockNumberIsTouched(true));
      if (
        valueIsValid.branchIsValid &&
        valueIsValid.applicationNumIsValid &&
        valueIsValid.blockNumberIsValid
      ) {
        dispatch(SecurityChequeReducerAction.updateShowChequeListGrid(true));
      }
    }
  };

  const onClickFileDetails = async (value) => {
    if (
      (screenModeValue &&
        screenModeValue !== "" &&
        screenModeValue === "MODIFY") ||
      props.screenMode === "CREATE"
    ) {
      setFilterTouchHandlersActive();
      if (
        valueIsValid.branchIsValid &&
        valueIsValid.applicationNumIsValid &&
        // valueIsValid.receiptDateIsValid &&
        !receiptDateValidDateError &&
        valueIsValid.repaymentTypeIsValid &&
        valueIsValid.capacityIsValid
      ) {
        dispatch(SecurityChequeReducerAction.updateShowChequeListGrid(false));
        dispatch(SecurityChequeReducerAction.updateShowFileDetailsInfo(true));
        setLoadFileInfoPanel(true);
      }
    } else if (
      screenModeValue &&
      screenModeValue !== "" &&
      screenModeValue === "VIEW"
    ) {
      dispatch(SecurityChequeReducerAction.updateBranchIsTouched(true));
      dispatch(
        SecurityChequeReducerAction.updateApplicationNumberIsTouched(true)
      );
      dispatch(SecurityChequeReducerAction.updateBlockNumberIsTouched(true));
      if (
        valueIsValid.branchIsValid &&
        valueIsValid.applicationNumIsValid &&
        valueIsValid.blockNumberIsValid
      ) {
        dispatch(SecurityChequeReducerAction.updateShowChequeListGrid(false));
        dispatch(SecurityChequeReducerAction.updateShowFileDetailsInfo(true));
        setLoadFileInfoPanel(true);
      }
    }
  };

  const closeDialog = () => {
    setOpen(false);
    setTimeout(() => {
      dispatch(SecurityChequeReducerAction.resetChequeDetailValues());
    }, 1000);
  };

  const onClearBtnClickHandler = () => {
    dispatch(SecurityChequeReducerAction.resetFilterValues());
    setReceiptDateValidDateError(false);
    dispatch(SecurityChequeReducerAction.resetChequeDetailValues());
    dispatch(SecurityChequeReducerAction.updateShowChequeListGrid(false));
    dispatch(SecurityChequeReducerAction.updateShowFileDetailsInfo(false));
    dispatch(SecurityChequeReducerAction.resetChequeListGridRows());
    dispatch(SecurityChequeReducerAction.resetFileDetailsData());
    dispatch(SecurityChequeReducerAction.resetChequeDetailsInfo());
    setLoadFileInfoPanel(false);
    dispatch(
      SecurityChequeReducerAction.updateSecurityChequeInitialStateAfterFilter(
        {}
      )
    );

    // remove all the touch handlers.
    dispatch(SecurityChequeReducerAction.resetAllTouchHandlers());
  };

  const onChangeBlockNumber = async (value) => {
    const latestFilterData = store.getState().securityCheque.filterValues;
    // reset  all the values on filter
    dispatch(SecurityChequeReducerAction.resetFilterValues());
    dispatch(
      SecurityChequeReducerAction.updateSecurityChequeInitialStateAfterFilter(
        {}
      )
    );
    // retaining back the last selected branch value & application Num &
    dispatch(
      SecurityChequeReducerAction.updateBranchValue(latestFilterData.branch)
    );
    await onChangeApplicationNum(latestFilterData.applicationNum);
    dispatch(SecurityChequeReducerAction.updateBlockNumberValue(value));
    if (value && value !== "") {
      const blockNumberResponse = await axios.post(
        "/securityCheque/getSecurityChequeData",
        {
          blockNumber: value,
        }
      );
      let record = blockNumberResponse.data;
      record.sanctionedDate = filterValues.sanctionedDate;
      record.ecdDate = filterValues.ecdDate;
      record.losStatus = filterValues.losStatus;
      dispatch(SecurityChequeReducerAction.updateFilterValues(record));
      const branchCodeValue = getSelectedBranchCode(latestFilterData.branch);
      const applicationNumResponse = await axios.post(
        "/losCustomer/getAppListByBranch",
        {
          branchName: latestFilterData.branch,
          screenMode:
            props.screenMode === "CREATE" ? props.screenMode : screenModeValue,
          branchCode: branchCodeValue,
        }
      );
      dispatch(
        SecurityChequeReducerAction.updateApplicationArray(
          applicationNumResponse.data.sort()
        )
      );
      dispatch(
        SecurityChequeReducerAction.updateApplicationValue(
          latestFilterData.applicationNum
        )
      );
      dispatch(
        SecurityChequeReducerAction.updateReceiptDate(record.receiptDate)
      );
      dispatch(
        SecurityChequeReducerAction.updateRepaymentTypeValue(
          record.repaymentType
        )
      );
      dispatch(
        SecurityChequeReducerAction.updateCapacityValue(record.capacity)
      );
      let gridrows = [...record.securityChequeDtl].map((row) => {
        let rowData = { ...row };
        rowData.id = rowData.chequeNum;
        rowData.chequeDate =
          rowData.chequeDate !== undefined && rowData.chequeDate !== null
            ? new Date(rowData.chequeDate)
            : null;
        return rowData;
      });
      dispatch(
        SecurityChequeReducerAction.updateChequeListGridRows([...gridrows])
      );
      dispatch(SecurityChequeReducerAction.updateChequeDetailData(record));
      dispatch(SecurityChequeReducerAction.updateChequeDetailsInfo(record));

      // gathering the latest filter values for updating the initial state.
      if (props.screenMode === "MODIFY" || screenModeValue === "MODIFY") {
        const latestFilterValues = store.getState().securityCheque.filterValues;
        let initialStateValue = { ...latestFilterValues };
        initialStateValue.gridrows = [gridrows];
        dispatch(
          SecurityChequeReducerAction.updateSecurityChequeInitialStateAfterFilter(
            { ...initialStateValue }
          )
        );
      }

      const fileDetailReponse = await axios.post(
        "/securityCheque/getFileDetails",
        {
          applicationNum: filterValues.applicationNum,
        }
      );
      if (fileDetailReponse.data.length > 0) {
        let fileData = fileDetailReponse.data[0];
        let fileDetails = {};
        fileDetails.applicationNum = filterValues.applicationNum;
        fileDetails.emiStartDate = fileData.emiCommDate;
        const ecdd = new Date(
          Number(fileData.firstEmiDueDate.split("/")[2]),
          Number(fileData.firstEmiDueDate.split("/")[1]) - 1,
          Number(fileData.firstEmiDueDate.split("/")[0])
        );
        const fbd = new Date(
          Number(fileData.billingDate.split("/")[2]),
          Number(fileData.billingDate.split("/")[1]) - 1,
          Number(fileData.billingDate.split("/")[0])
        );
        fileDetails.emiDueDate = ecdd;
        fileDetails.fbdDay = fbd;
        fileDetails.emiAmt = fileData.sanctionedEmiAmt;
        dispatch(
          SecurityChequeReducerAction.updateFileDetailsData(fileDetails)
        );
        dispatch(SecurityChequeReducerAction.updateShowFileDetailsInfo(true));
      }
    }
  };

  const onDlgOkClick = () => {
    // re-dispatch event of no of cheques. to show error.
    dispatch(
      SecurityChequeReducerAction.updateNumberOfCheques(
        chequeDetailData.noOfCheque
      )
    );
    dispatch(
      SecurityChequeReducerAction.updateStartChequeNumberErrorHandler(true)
    );
    dispatch(SecurityChequeReducerAction.updateChequeTypeIsTouched(true));
    dispatch(SecurityChequeReducerAction.updateNumOfChequesErrorHandler(true));
    dispatch(SecurityChequeReducerAction.updateMICRTypeIsTouched(true));
    dispatch(SecurityChequeReducerAction.updateBankOptionIsTouched(true));
    dispatch(SecurityChequeReducerAction.updateMICRTouched(true));
    dispatch(SecurityChequeReducerAction.updateDraweeBankIsTouched(true));
    dispatch(SecurityChequeReducerAction.updateDraweeBranchIsTouched(true));
    dispatch(SecurityChequeReducerAction.updateIFSCIsTouched(true));
    dispatch(SecurityChequeReducerAction.updateAccountNumIsTouched(true));
    dispatch(
      SecurityChequeReducerAction.updateAccountHolderNameIsTouched(true)
    );
    if (
      valueIsValid.startChequeNumberIsValid &&
      valueIsValid.chequeTypeIsValid &&
      valueIsValid.noOfChequeIsValid &&
      valueIsValid.micrTypeIsValid &&
      valueIsValid.bankOptionIsValid &&
      valueIsValid.micrNumberIsValid &&
      valueIsValid.drawerBankIsValid &&
      valueIsValid.drawerBranchIsValid &&
      valueIsValid.ifscIsValid &&
      valueIsValid.accNumberIsValid &&
      valueIsValid.accHolderNameIsValid
    ) {
      if (!dlgInputMode) {
        const chequeNumValue = chequeDetailData.chequeNum;
        const updatedRecord = { ...chequeDetailData };
        let recordsData = [...chequeGridRows];
        let updateRows = recordsData.map((record) => {
          if (record.chequeNum === chequeNumValue) {
            return updatedRecord;
          }
          return record;
        });
        dispatch(
          SecurityChequeReducerAction.updateChequeListGridRows([...updateRows])
        );
      } else {
        const rowsData = [];
        const firstrecord = { ...chequeDetailData };
        let chequeNum = firstrecord.startChequeNumber;
        for (
          let index = Number(chequeNum);
          index < Number(chequeNum) + Number(firstrecord.noOfCheque);
          index++
        ) {
          let record = { ...firstrecord };
          record.chequeNum = index.toString().padStart("6", "0");
          record.id = index.toString().padStart("6", "0");
          record.applicationNum = filterValues.applicationNum;
          record.chequeStatus = "ENTRY";
          rowsData.push(record);
        }
        dispatch(
          SecurityChequeReducerAction.updateChequeListGridRows([...rowsData])
        );
        // gather the filter data & grid rows as initial state configured for Create mode.
        let initialStateValue = { ...filterValues };
        initialStateValue.gridrows = rowsData;
        dispatch(
          SecurityChequeReducerAction.updateSecurityChequeInitialStateAfterFilter(
            { ...initialStateValue }
          )
        );
      }
      dispatch(SecurityChequeReducerAction.updateShowChequeListGrid(true));
      setOpen(false);
    }
  };

  const handleCloseForModeSwitch = () => {
    setModeSwitchToView(false);
    setModeSwitchDlgOpen(false);
  };

  const handleOkForModeSwitch = async () => {
    // get the data from backend & load.
    let currentStateValue = { ...filterValues };
    const blockNumberValue = currentStateValue.blockNumber;
    await onChangeBlockNumber(blockNumberValue);
    // no changes exists then load the nums.
    const branchCodeValue = getSelectedBranchCode(currentStateValue.branch);
    const response = await axios.post("/losCustomer/getAppListByBranch", {
      branchName: currentStateValue.branch,
      screenMode: "VIEW",
      branchCode: branchCodeValue,
    });
    const appnums = [...response.data];
    dispatch(SecurityChequeReducerAction.updateApplicationArray([...appnums]));

    setModeSwitchToView(false);
    setModeSwitchDlgOpen(false);
    dispatch(SecurityChequeReducerAction.updateScreenMode("VIEW"));
  };

  const onSwitchToViewMode = async () => {
    // before switch to view mode check for changes on the page.
    const blockNumberValue = filterValues.blockNumber;
    if (blockNumberValue && blockNumberValue !== "") {
      // get the data for block Number from backend.
      try {
        const blockNumberResponse = await axios.post(
          "/securityCheque/getSecurityChequeData",
          {
            blockNumber: blockNumberValue,
          }
        );
        let record = blockNumberResponse.data;
        // reform the structure for Comparison.
        let originalDataFilterValues = {
          branch: record.branch,
          applicationNum: record.applicationNum,
          customerId: record.customerId,
          receiptDate: record.receiptDate,
          blockNumber: record.blockNumber,
          repayApp: record.repayApp,
          repayMode: record.repayMode,
          repaymentType: record.repaymentType,
          sanctionedDate: record.sanctionedDate,
          capacity: record.capacity,
          ecdDate: record.ecdDate,
          losStatus: record.losStatus,
        };
        // reform the grid rows also.
        let originalDataGridRows = [...record.securityChequeDtl].map((row) => {
          let rowData = {};
          rowData.id = row.chequeNum;
          rowData.applicationNum = row.applicationNum;
          rowData.chequeNum = row.chequeNum;
          rowData.chequeDate =
            row.chequeDate !== undefined && row.chequeDate !== null
              ? dayjs(new Date(row.chequeDate)).format("MM/DD/YYYY")
              : null;
          rowData.repayAmt = row.repayAmt;
          rowData.chequeAmt = row.chequeAmt;
          rowData.chequeStatus = row.chequeStatus;
          return rowData;
        });
        let originalStateData = { ...originalDataFilterValues };
        originalStateData.gridRows = originalDataGridRows;

        // now reforming the current state values to new Structure.
        let currentStateFilterValues = {
          branch: filterValues.branch,
          applicationNum: filterValues.applicationNum,
          customerId: filterValues.customerId,
          receiptDate: filterValues.receiptDate,
          blockNumber: filterValues.blockNumber,
          repayApp: filterValues.repayApp,
          repayMode: filterValues.repayMode,
          repaymentType: filterValues.repaymentType,
          sanctionedDate: filterValues.sanctionedDate,
          capacity: filterValues.capacity,
          ecdDate: filterValues.ecdDate,
          losStatus: filterValues.losStatus,
        };
        // now reform the current grid rows for comparison.
        let currentStateGridRows = [...chequeGridRows].map((row) => {
          let rowData = {};
          rowData.id = row.chequeNum;
          rowData.applicationNum = row.applicationNum;
          rowData.chequeNum = row.chequeNum;
          rowData.chequeDate =
            row.chequeDate !== undefined && row.chequeDate !== null
              ? dayjs(new Date(row.chequeDate)).format("MM/DD/YYYY")
              : null;
          rowData.repayAmt = row.repayAmt;
          rowData.chequeAmt = row.chequeAmt;
          rowData.chequeStatus = row.chequeStatus;
          return rowData;
        });
        let currentStateValue = { ...currentStateFilterValues };
        currentStateValue.gridRows = currentStateGridRows;
        if (
          ((screenModeValue &&
            screenModeValue !== "" &&
            screenModeValue === "MODIFY") ||
            props.screenMode === "CREATE") &&
          JSON.stringify(currentStateValue) !==
            JSON.stringify(originalStateData)
        ) {
          setModeSwitchToView(true);
          setModeSwitchDialogMessage(
            "Do you want to discard the changes and continue to View Mode ?"
          );
          setModeSwitchDialogTitleMessage("Confirmation");
          setModeSwitchDlgOpen(true);
        } else {
          // no changes exists then load the nums.
          const branchCodeValue = getSelectedBranchCode(
            currentStateValue.branch
          );
          const response = await axios.post("/losCustomer/getAppListByBranch", {
            branchName: currentStateValue.branch,
            screenMode: "VIEW",
            branchCode: branchCodeValue,
          });
          const appnums = [...response.data];
          dispatch(
            SecurityChequeReducerAction.updateApplicationArray([...appnums])
          );
          dispatch(SecurityChequeReducerAction.updateScreenMode("VIEW"));
        }
      } catch (error) {
        console.log(error);
        throw Error(error);
      }
    } else {
      // with out filling the voucher num also user can switch across the modes.
      // no changes exists then load the nums.
      const currentStateValue = { ...filterValues };
      if (currentStateValue.branch && currentStateValue.branch !== "") {
        const branchCodeValue = getSelectedBranchCode(currentStateValue.branch);
        const response = await axios.post("/losCustomer/getAppListByBranch", {
          branchName: currentStateValue.branch,
          screenMode: "VIEW",
          branchCode: branchCodeValue,
        });
        const appnums = [...response.data];
        dispatch(
          SecurityChequeReducerAction.updateApplicationArray([...appnums])
        );
        dispatch(SecurityChequeReducerAction.updateScreenMode("VIEW"));
      } else {
        dispatch(SecurityChequeReducerAction.updateScreenMode("VIEW"));
      }
    }
  };

  const onSwitchToModifyMode = async () => {
    // check whether the seelcted application loan is closed.
    let currentStateValue = { ...filterValues };
    if (currentStateValue.branch && currentStateValue.branch !== "") {
      const applicationNumValue = currentStateValue.applicationNum;
      if (
        applicationNumValue &&
        applicationNumValue !== "" &&
        applicationNumValue !== null &&
        applicationNumValue !== undefined
      ) {
        const losCustomerResponse = await axios.post(
          "/losCustomer/getLoanStatusByAppNum",
          {
            appNum: applicationNumValue,
          }
        );
        const applicationLoanStatus = losCustomerResponse.data;
        if (applicationLoanStatus.status) {
          // when status is true -> loan was closed.
          setModeSwitchDialogMessage(
            "Loan was Closed for this Application Number so you can't Modify. Please Wait Redirecting to View Mode."
          );
          setModeSwitchDialogTitleMessage("Information");
          setModeSwitchDlgOpen(true);
          setTimeout(() => {
            dispatch(SecurityChequeReducerAction.updateScreenMode("VIEW"));
            setModeSwitchDlgOpen(false);
          }, 7000);
        } else {
          // when status is false -> loan was not closed.
          // before switching to modify mode load the Application Nums for Modify mode.
          const branchCodeValue = getSelectedBranchCode(
            currentStateValue.branch
          );
          const response = await axios.post("/losCustomer/getAppListByBranch", {
            branchName: currentStateValue.branch,
            screenMode: "MODIFY",
            branchCode: branchCodeValue,
          });
          const appnums = [...response.data];
          dispatch(
            SecurityChequeReducerAction.updateApplicationArray([...appnums])
          );
          dispatch(SecurityChequeReducerAction.updateScreenMode("MODIFY"));
        }
      } else {
        // before switching to modify mode load the Application Nums for Modify mode.
        const branchCodeValue = getSelectedBranchCode(currentStateValue.branch);
        const response = await axios.post("/losCustomer/getAppListByBranch", {
          branchName: currentStateValue.branch,
          screenMode: "MODIFY",
          branchCode: branchCodeValue,
        });
        const appnums = [...response.data];
        dispatch(
          SecurityChequeReducerAction.updateApplicationArray([...appnums])
        );
        dispatch(SecurityChequeReducerAction.updateScreenMode("MODIFY"));
      }
    } else {
      dispatch(SecurityChequeReducerAction.updateScreenMode("MODIFY"));
    }
  };

  return (
    <>
      <AccordianContainer
        id="accord"
        title={
          props.screenMode === "CREATE"
            ? "Security PDC Create"
            : screenModeValue === "VIEW"
            ? "Security PDC View"
            : "Security PDC Modify"
        }
        initialOpen={true}
        sx={{ margin: "8px !important" }}
      >
        {props.screenMode !== "CREATE" && (
          <Box
            sx={{
              marginBottom: "8px",
              marginTop: "-1%",
              display: "flex",
              gap: "8px",
              justifyContent: "flex-end",
            }}
          >
            <Tooltip title="View Mode(Ctrl+E)" placement="top">
              <IconButton
                aria-label="View"
                color="primary"
                onClick={() => {
                  onSwitchToViewMode();
                }}
                ref={viewRef}
              >
                <Preview />
              </IconButton>
            </Tooltip>
            <Tooltip title="Modify Mode(Ctrl+M)" placement="top">
              <IconButton
                aria-label="Modify"
                color="primary"
                onClick={() => {
                  onSwitchToModifyMode();
                }}
                ref={modifyRef}
              >
                <Edit />
              </IconButton>
            </Tooltip>
          </Box>
        )}

        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomAutoComplete
              variant="standard"
              type="text"
              placeholder="Select Branch"
              label="Branch"
              required={true}
              autoCompleteValues={filterValues.branchArray}
              value={filterValues.branch}
              onChange={(e, value) => {
                const branchValue =
                  value !== undefined && value !== null && value !== ""
                    ? value.label
                    : null;
                let currentStateValue = { ...filterValues };
                currentStateValue.branch = branchValue;
                currentStateValue.gridrows = chequeGridRows;
                if (
                  ((screenModeValue &&
                    screenModeValue !== "" &&
                    screenModeValue === "MODIFY") ||
                    props.screenMode === "CREATE") &&
                  Object.keys(securityChequeInitialStateAfterFilter).length >
                    0 &&
                  JSON.stringify(currentStateValue) !==
                    JSON.stringify(securityChequeInitialStateAfterFilter)
                ) {
                  openConfirmDlg("branch", branchValue);
                } else {
                  // when values are same or in case of view mode no dialog not required.
                  branchOnChangeHandler(branchValue);
                }
              }}
              onBlur={() => {
                dispatch(
                  SecurityChequeReducerAction.updateBranchIsTouched(true)
                );
              }}
            />
            {branchHasError && <p className="error">Please Select Branch</p>}
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomAutoComplete
              variant="standard"
              type="text"
              placeholder="Select Application Number"
              label="Application Number"
              required={true}
              autoCompleteValues={filterValues.applicationArray}
              value={filterValues.applicationNum}
              onChange={(event, value) => {
                let currentStateValue = { ...filterValues };
                currentStateValue.applicationNum = value;
                currentStateValue.gridrows = chequeGridRows;
                if (
                  ((screenModeValue &&
                    screenModeValue !== "" &&
                    screenModeValue === "MODIFY") ||
                    props.screenMode === "CREATE") &&
                  Object.keys(securityChequeInitialStateAfterFilter).length >
                    0 &&
                  JSON.stringify(currentStateValue) !==
                    JSON.stringify(securityChequeInitialStateAfterFilter)
                ) {
                  openConfirmDlg("applicationNum", value);
                } else {
                  // when values are same or in case of view mode no dialog not required.
                  onChangeApplicationNum(value);
                }
              }}
              onBlur={() => {
                dispatch(
                  SecurityChequeReducerAction.updateApplicationNumberIsTouched(
                    true
                  )
                );
              }}
            />
            {applicationHasError && (
              <p className="error">Please Select Application Number</p>
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Customer ID"
              id="customerID"
              variant="standard"
              value={filterValues.customerId}
              type="text"
              placeholder="Customer ID."
              onChange={(event) => {}}
            />
          </Grid>

          {(props.screenMode === "MODIFY" ||
            props.screenMode === "VIEW" ||
            screenModeValue === "MODIFY" ||
            screenModeValue === "VIEW") && (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                disabled={false}
                required={true}
                label="Block Number"
                id="blockNumber"
                variant="standard"
                type="text"
                placeholder="Select Block Number"
                autoCompleteValues={filterValues.blockNumberArray}
                value={filterValues.blockNumber}
                onChange={(event, value) => {
                  let currentStateValue = { ...filterValues };
                  currentStateValue.blockNumber = value;
                  currentStateValue.gridrows = chequeGridRows;
                  if (
                    ((screenModeValue &&
                      screenModeValue !== "" &&
                      screenModeValue === "MODIFY") ||
                      props.screenMode === "CREATE") &&
                    Object.keys(securityChequeInitialStateAfterFilter).length >
                      0 &&
                    JSON.stringify(currentStateValue) !==
                      JSON.stringify(securityChequeInitialStateAfterFilter)
                  ) {
                    openConfirmDlg("blockNumber", value);
                  } else {
                    // when values are same or in case of view mode no dialog not required.
                    onChangeBlockNumber(value);
                  }
                }}
              />
              {blockNumberHasError && (
                <p className="error">Please Select Block Number</p>
              )}
            </Grid>
          )}

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomDateField
              label="Receipt Date"
              variant="standard"
              disabled={true}
              required={false}
              value={filterValues.receiptDate}
              onChange={(value) => {
                dispatch(SecurityChequeReducerAction.updateReceiptDate(value));
                if (value !== null && value !== undefined && value !== "") {
                  const invalidFlag =
                    new Date(value).toDateString() !== "Invalid Date" &&
                    new Date(value).toLocaleDateString().slice(-4) >= "1970" &&
                    new Date(value).toLocaleDateString().slice(-4) <= "2055"
                      ? false
                      : true;
                  setReceiptDateValidDateError(invalidFlag);
                  dispatch(
                    SecurityChequeReducerAction.updateSaveBtnDisable(
                      invalidFlag
                    )
                  );
                } else {
                  setReceiptDateValidDateError(false);
                  dispatch(
                    SecurityChequeReducerAction.updateSaveBtnDisable(
                      value === null || value === undefined || value === ""
                    )
                  );
                }
              }}
              onBlur={(value) => {
                dispatch(SecurityChequeReducerAction.updateReceiptDate(value));
                if (value !== null && value !== undefined && value !== "") {
                  new Date(value).toDateString() !== "Invalid Date" &&
                  new Date(value).toLocaleDateString().slice(-4) >= "1970" &&
                  new Date(value).toLocaleDateString().slice(-4) <= "2055"
                    ? setReceiptDateValidDateError(false)
                    : setReceiptDateValidDateError(true);
                } else {
                  setReceiptDateValidDateError(false);
                }
              }}
            ></CustomDateField>
            {/* {(receiptDateValidDateError || receiptDateHasError) && (
              <p className="error">Please Enter Valid Date</p>
            )} */}
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Repay Application"
              id="repayApp"
              variant="standard"
              value={filterValues.repayApp}
              type="text"
              placeholder="Repay Application."
              onChange={(event) => {}}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Repay Mode"
              id="repayMode"
              variant="standard"
              value={filterValues.repayMode}
              type="text"
              placeholder="Repay Mode."
              onChange={(event) => {}}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomAutoComplete
              disabled={
                screenModeValue &&
                screenModeValue !== "" &&
                screenModeValue !== "CREATE"
              }
              required={props.screenMode === "CREATE"}
              label="Repayment Type"
              id="repaymentType"
              variant="standard"
              value={filterValues.repaymentType}
              type="text"
              placeholder="Select Repayment Type."
              autoCompleteValues={filterValues.repaymentTypeArray}
              onChange={(event, value) => {
                dispatch(
                  SecurityChequeReducerAction.updateRepaymentTypeValue(value)
                );
                dispatch(
                  SecurityChequeReducerAction.updateSaveBtnDisable(
                    value === null || value === "" || value === undefined
                  )
                );
              }}
              onBlur={(event, value) => {
                dispatch(
                  SecurityChequeReducerAction.updateRepaymentTypeIsTouched(true)
                );
              }}
            />
            {repaymentTypeHasError && (
              <p className="error">Please Select Repayment Type</p>
            )}
          </Grid>
          {filterValues.losStatus &&
            filterValues.losStatus !== "" &&
            filterValues.losStatus === "Sanctioned" && (
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDateField
                  disabled={true}
                  required={false}
                  label="Sanctioned Date"
                  id="sanctionedDate"
                  variant="standard"
                  value={filterValues.sanctionedDate}
                  type="text"
                  placeholder=""
                  onChange={(event) => {}}
                />
              </Grid>
            )}
          {filterValues.losStatus &&
            filterValues.losStatus !== "" &&
            filterValues.losStatus !== "Sanctioned" && (
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDateField
                  disabled={true}
                  required={false}
                  label="ECD Date"
                  id="ecdDate"
                  variant="standard"
                  value={filterValues.ecdDate}
                  type="text"
                  placeholder=""
                  onChange={(event) => {}}
                />
              </Grid>
            )}
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomAutoComplete
              type="text"
              disabled={
                screenModeValue &&
                screenModeValue !== "" &&
                screenModeValue !== "CREATE"
              }
              required={props.screenMode === "CREATE"}
              label="Capacity"
              id="capacity"
              variant="standard"
              placeholder={"Select Capacity"}
              autoCompleteValues={filterValues.capacityArray}
              value={filterValues.capacity}
              onChange={(event, value) => {
                dispatch(
                  SecurityChequeReducerAction.updateCapacityValue(value)
                );
                dispatch(
                  SecurityChequeReducerAction.updateSaveBtnDisable(
                    value === null || value === "" || value === undefined
                  )
                );
              }}
              onBlur={(event, value) => {
                dispatch(
                  SecurityChequeReducerAction.updateCapacityIsTouched(true)
                );
              }}
            />
            {capacityHasError && (
              <p className="error">Please Select Capacity</p>
            )}
          </Grid>
        </Grid>
        <Box
          sx={{
            marginTop: "12px",
            marginBottom: "8px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Tooltip title="Ctrl+R" placement="top">
            <Button
              variant="contained"
              type="submit"
              sx={{
                marginTop: "8px",
                marginBottom: "4px",
                display: "flex",
                marginLeft: "8px",
                justifyContent: "center",
              }}
              onClick={() => {
                onClickChequeDetails();
              }}
              ref={detailChequeRef}
            >
              Cheque Details
            </Button>
          </Tooltip>
          {filterValues.losStatus !== "Sanctioned" && (
            <Tooltip title="Ctrl+F" placement="top">
              <Button
                variant="contained"
                type="submit"
                sx={{
                  marginTop: "8px",
                  marginBottom: "4px",
                  display: "flex",
                  marginLeft: "8px",
                  justifyContent: "center",
                }}
                onClick={() => {
                  onClickFileDetails();
                }}
                ref={detailRef}
              >
                File Details
              </Button>
            </Tooltip>
          )}
          <Tooltip title="Ctrl+D" placement="top">
            <Button
              sx={{
                marginTop: "8px",
                marginBottom: "4px",
                display: "flex",
                marginLeft: "8px",
                justifyContent: "center",
                color: "white",
                backgroundColor: "black",
              }}
              onMouseOver={({ target }) => {
                target.style.backgroundColor = "black";
                target.style.color = "white";
              }}
              variant="contained"
              onClick={() => {
                onClearBtnClickHandler();
              }}
              ref={clearRef}
            >
              Clear
            </Button>
          </Tooltip>
        </Box>
      </AccordianContainer>
      {showChequeListGrid && (
        <SecurityChequeList
          screenMode={
            props.screenMode === "CREATE" ? props.screenMode : screenModeValue
          }
          onClearBtnClickHandler={onClearBtnClickHandler}
        />
      )}
      {showFileDetailsInfo && loadFileInfoPanel && <FileDetailsInfo />}
      <Dialog
        open={open}
        fullScreen
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          <h4>{"Security PDC Information"}</h4>
        </DialogTitle>
        <DialogContent>
          <SecurityChequeInfo dlgInputMode={dlgInputMode} />
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+Q" placement="top">
            <Button onClick={() => closeDialog()} ref={cancelRef}>
              CANCEL
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+K" placement="top">
            <Button disabled={false} onClick={() => onDlgOkClick()} ref={okRef}>
              ok
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Dialog
        open={confirmDlgOpen}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{confirmDlgTitleMsg}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {confirmDlgMsg}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+Q" placement="top">
            <Button onClick={handleConfirmDlgClose} ref={cancelConfirmRef}>
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+Y" placement="top">
            <Button onClick={handleConfirmDlgOk} ref={yesConfirmRef}>
              Yes
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Dialog
        open={modeSwitchDlgOpen}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{modeSwitchDialogTitleMessage}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {modeSwitchDialogMessage}
          </DialogContentText>
        </DialogContent>
        {modeSwitchToView && (
          <DialogActions>
            <Tooltip title="Ctrl+Q" placement="top">
              <Button onClick={handleCloseForModeSwitch} ref={cancelModeRef}>
                Cancel
              </Button>
            </Tooltip>
            <Tooltip title="Ctrl+Y" placement="top">
              <Button onClick={handleOkForModeSwitch} ref={yesModeRef}>
                Yes
              </Button>
            </Tooltip>
          </DialogActions>
        )}
      </Dialog>
    </>
  );
};
export default SecurityChequeFilter;
